import { render, staticRenderFns } from "./tuinrenovatie.vue?vue&type=template&id=1d27c12c"
import script from "./tuinrenovatie.vue?vue&type=script&lang=js"
export * from "./tuinrenovatie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports